export enum UserActions {
    REGISTER_USER = 'REGISTER_USER',
    HAS_ACCOUNT = 'HAS_ACCOUNT',
    RETRIEVE_USER_PROFILE = 'RETREIVE_USER_PROFILE',
    UPLOAD_POST = 'UPLOAD_POST',
    RENDER_FEED = 'RENDER_FEED',
    PROFILE_PICTURE = 'PROFILE_PICTURE'
}